import { splitCamelCaseIntoParts } from '@squareup/dex-utils-text';

function toApiId(api: string | undefined): string {
  return `${api?.toLocaleLowerCase() || ''}-api`;
}

function toEndpointId(endpoint: string | undefined): string {
  return splitCamelCaseIntoParts(endpoint || '')
    .map((value) => value.toLowerCase())
    .join('-');
}

const entityTypes = [
  'api',
  'api-endpoint',
  'entity',
  'webhook',
  'type',
] as const;
type SparkupEntityType = typeof entityTypes[number];

function isSparkupEntityType(
  entityType: string
): entityType is SparkupEntityType {
  return entityTypes.includes(entityType as SparkupEntityType);
}

function convertSparkupEntityToUrl(
  baseUrl: string,
  entityType: string,
  tokens: string[],
  hash?: string | undefined
): string {
  if (!isSparkupEntityType(entityType)) {
    if (hash) {
      return `${baseUrl}#${hash}`;
    } else {
      return baseUrl;
    }
  }

  let url = baseUrl;
  switch (entityType) {
    case 'api':
      url += `/${toApiId(tokens[0])}`;
      break;
    case 'api-endpoint':
      url += `/${toApiId(tokens[0])}/${toEndpointId(tokens[1])}`;
      break;
    case 'entity':
    case 'type':
      url += `/objects/${tokens[0]}`;
      break;
    case 'webhook':
      url += `/webhooks/${tokens[0]}`;
      break;
    default:
      break;
  }

  if (hash) {
    url += `#${hash}`;
  }

  return url;
}

export { convertSparkupEntityToUrl };
